// Lot 705 — Code d'invitation (?ref=XXXX) : capturé à TOUTE entrée (web, lien ouvert dans l'app) et mémorisé 90 jours.
// Avant : lu seulement par l'écran d'inscription → perdu sur « Découvrir », au rechargement, et surtout quand l'invité
// installe l'app depuis le store après avoir cliqué le lien.
const KEY = "yalola.ref";
export const REF_TTL_MS = 90 * 86400000;
const CODE_RE = /^[A-Z0-9]{4,12}$/;

export const normalizeRefCode = (raw) => {
  const c = String(raw || "").trim().toUpperCase();
  return CODE_RE.test(c) ? c : "";
};

// Extrait le code d'une URL (https://yalola.app/?ref=W3APJ4, yalola://…?ref=…) ; "" si absent / invalide.
export const refCodeFromUrl = (url) => {
  try {
    const q = String(url || "").split("?")[1] || "";
    return normalizeRefCode(new URLSearchParams(q.split("#")[0]).get("ref"));
  } catch { return ""; }
};

export const storeRefCode = (code) => {
  const c = normalizeRefCode(code);
  if (!c) return "";
  try { localStorage.setItem(KEY, JSON.stringify({ code: c, at: Date.now() })); } catch { /* noop */ }
  return c;
};

export const storedRefCode = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "null");
    if (!v || !v.code || Date.now() - Number(v.at || 0) > REF_TTL_MS) return "";
    return normalizeRefCode(v.code);
  } catch { return ""; }
};

export const clearRefCode = () => { try { localStorage.removeItem(KEY); } catch { /* noop */ } };

// À appeler au démarrage et à chaque lien reçu par l'app : mémorise le code s'il y en a un, le renvoie.
export const captureRefCode = (url = typeof window !== "undefined" ? window.location.href : "") => storeRefCode(refCodeFromUrl(url));
